export const getInstance = () => {
	// @ts-ignore
	return window.appInsights ?? null;
};

export const trackEvent = (data: any) => {
	try {
		getInstance()?.trackEvent(data);
	} catch (err) {
		console.error("Application insights trackEvent", err);
	}
};

export const trackException = (exception: Error | unknown) => {
	try {
		getInstance()?.trackException(exception);
	} catch (err) {
		console.error("Application insights trackException", err);
	}
};

export const trackMetric = (data: any) => {
	try {
		getInstance()?.trackMetric(data);
	} catch (err) {
		console.error("Application insights trackMetric", err);
	}
};

export const trackTrace = (data: any) => {
	try {
		getInstance()?.trackTrace(data);
	} catch (err) {
		console.error("Application insights trackTrace", err);
	}
};
